import style from "./style.module.sass";

const ResponseTabs = ({ setActiveTab, activeTab, contractorCounter, customerCounter }) => {
    return (
        <div className={style.response__mode}>
            <h6 className="cabinet__redesign_subtitle">Режим аккаунта:</h6>
            <div className={style.tabs_wrapper}>
                <button
                    type="button"
                    onClick={() => {
                        setActiveTab("customer");
                    }}
                    className={`${style.tab} ${activeTab === "customer" ? style.active : ""}`}
                    id="btn1">
                    <p>Я заказчик{customerCounter > 0 && <span>+{customerCounter}</span>}</p>
                </button>
                <button
                    type="button"
                    onClick={() => {
                        setActiveTab("contractor");
                    }}
                    className={`${style.tab} ${activeTab === "contractor" ? style.active : ""}`}
                    id="btn2">
                    <p>Я исполнитель{contractorCounter > 0 && <span>+{contractorCounter}</span>}</p>
                </button>
            </div>
        </div>
    );
};

export default ResponseTabs;
